import axios from 'axios';

const state = () => ({
  availableRooms: [],
});

const getters = {
  availableRoomById: (state) => (rid) => {
    console.log(rid);
    return state.availableRooms.find((room) => room.rid == rid);
  },
};

const mutations = {
  SET_AVAILABLE_ROOMS(state, rooms) {
    console.log('SET_AVAILABLE_ROOMS', rooms);
    state.availableRooms = rooms;
  },
};

const actions = {
  getAvailableRooms({ commit, rootState }, filter) {
    console.log(
      'getAvailableRooms filter: ',
      filter.date,
      filter.room,
      filter.adult,
      filter.child,
    );
    return new Promise((resolve, reject) => {
      axios
        .get('AvailabilityRoomInfo', {
          params: {
            hno: rootState.hno,
            startOdate: filter.date.from,
            endOdate: filter.date.to,
            roomQty: filter.room,
            lang: rootState.lang,
            adultCnt: filter.adult,
            childCnt: filter.child,
          },
        })
        .then((resp) => {
          let rooms = resp.data;
          rooms.map((room) => {
            room.price1 = parseInt(room.price1.split(';')[0]);
            room.price2 = parseInt(room.price2.split(';')[0]);
          });
          commit('SET_AVAILABLE_ROOMS', rooms);
          resolve(rooms);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateMemberToken({ rootState }, token) {
    return new Promise((resolve, reject) => {
      axios
        .post('Member/UpdateMemberToken', {
          userid: rootState.user.personalInfo.userid,
          token: token,
        })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
